var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"accel-layer"},[_c('div',{staticClass:"accel-layer__container",style:(_vm.getStyles)},[(_vm.debug)?_c('div',{staticClass:"debug"},[_c('pre',{ref:"debug"},[_vm._v("      "+_vm._s(_vm.debugText)+"\n      ")]),_vm._v("\n\n      "+_vm._s(_vm.getStyles)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a800c87","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccelLayer/index.vue
// module id = null
// module chunks = 